import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发送")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("通知所属领导")
const _hoisted_4 = { style: {"margin-left":"65px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重复发送")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount, computed } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs';
import store from '@/store/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/salaries/mail/situation': fetchList,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 薪酬邮件发送
  'POST/salaries/mail/send': sendEmailApi,
  // 团队内员工列表
  'GET/org_user/list': org_userListApi,
  // 通知领导审核工资
  'POST/salaries/distributes/notify/leader': notifyLeaderApi,
} = Api


const multipleSelection = ref<any>([])
let fullUserList: Ref<any[]> = ref([])
let compnyList: Ref<any[]> = ref([])
let orgList: Ref<any[]> = ref([])
let associationOrgUser: Ref<any[]> = ref([])
const btnFg = ref<boolean>(false)

onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })
  companyApi().then((_comp: any) => {
    compnyList.value = _comp
  })
  organizationsApi().then((_org: any) => {
    orgList.value = _org
  })
  org_userListApi().then((_item: any) => {
    associationOrgUser.value = _item
  })
})

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm 
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    type: "TIME",
    label: "月份",
    value: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    upKey: 'month',
    props: {
      type: 'month',
      clearable: true,
      'default-value': null,
    }
  },
  {
    type: 'SELECT',
    label: '员工',
    value: [],
    upKey: 'userIds',
    options: fullUserList,
    // element 属性
    props: { placeholder: '请选择员工', multiple: true, 'collapse-tags': true, style: 'width: 250px', clearable: true },
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: organizationsApi,
    seleProps: { label: 'name', valueName: 'id', },
    props: { placeholder: '请选择团队', clearable: true }
  },
  {
    type: 'SELECT',
    selectType: 'GROUP',
    label: '公司',
    value: '',
    upKey: 'companyId',
    options: store.getters.sysCompany,
    seleProps: { label: 'name', valueName: 'id', },
    props: { placeholder: '请选择公司', clearable: true }
  },
])


// 发送邮件
const sendFrom: any = reactive({
  month: '',
  orgId: '',
  companyId: '',
  remarks: '',
  userIds: [],
  deleteUserIds: [],
  repeat: 'false',

})
const casProp = reactive({
  multiple: true,
  children: 'userVOS',
  value: 'userId',
})

const sendFromEle: any = ref(null)
const sendFg = ref<boolean>(false)

const sendHandle = async () => {
  /* MI_modifyForm({}, sendConfig, sendFg, async(params: any) => {
    await sendEmailApi(params)
    ElMessage.success('发送成功')
    sendFg.value = false
  }) */
  let deleteUserIds = sendFrom.deleteUserIds.reduce((arr: number[], _user: number[]) => {
    arr.push(_user[1])
    return arr
  }, [])

  btnFg.value = true
  try {
    await sendEmailApi({
    ...sendFrom, 
    deleteUserIds,
    repeat: sendFrom.repeat === 'true' ? true : false,
  })
    btnFg.value = false
    ElMessage.success('发送成功')
    sendFg.value = false
  } catch (error) {
    btnFg.value = false
  }
}

// 通知领导
const confirmTips = computed(() => {
  return sendFrom.userIds.map((_user: string) => {
    let userObj = fullUserList.value.find(e => e.userId === _user)
    return userObj.label
  })
})
const notifyFromEle: any = ref(null)
const notifyFg = ref<boolean>(false)
const sendNotify = () => {
  btnFg.value = true
  notifyFromEle.value.validate((valid: boolean) => {
    if (valid) {

      ElMessageBox.confirm(
        '是否确认通知该领导：' + confirmTips.value ,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        return notifyLeaderApi({ids: sendFrom.userIds.join(',')}, { contentType: 'formData'})
      }).then(() => {
        ElMessage.success('成功')
        btnFg.value = false
        notifyFg.value = false
      }).catch(()=> {
        btnFg.value = false
      })




     
    } else {
      btnFg.value = false
      return false
    }
  })
}





return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlexibleForm, _mergeProps({
      title: true,
      searchConfig: searchConfig.value
    }, {
      onSearchFn: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData)($event, {}, 1)))
    }), null, 16),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (sendFg.value = true)),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })), [
        [_directive_permission, 'Write']
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (notifyFg.value = true))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })), [
        [_directive_permission, 'Write']
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[3] || (_cache[3] = (rows) => { multipleSelection.value = rows })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "userName"
        }),
        _createVNode(_component_el_table_column, {
          label: "月份",
          prop: "month"
        }),
        _createVNode(_component_el_table_column, {
          label: "邮箱",
          prop: "mail"
        }),
        _createVNode(_component_el_table_column, {
          label: "发送时间",
          prop: "createdAt"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.createdAt).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.status ? '成功' : '失败'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "remarks",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "发送邮件",
      onClose: _cache[14] || (_cache[14] = ($event: any) => (sendFromEle.value.resetFields())),
      modelValue: sendFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((sendFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (sendFg.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          onClick: sendHandle,
          loading: btnFg.value,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "sendFromEle",
          ref: sendFromEle,
          model: _unref(sendFrom),
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "月份：",
              prop: "month"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "month",
                  modelValue: _unref(sendFrom).month,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(sendFrom).month) = $event)),
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请选择月份"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "员工：",
              prop: "userIds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(sendFrom).userIds,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(sendFrom).userIds) = $event)),
                  placeholder: "请选择员工",
                  multiple: "",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullUserList), (_user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: _user.label,
                        value: _user.userId
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "团队：",
              prop: "orgId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(sendFrom).orgId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(sendFrom).orgId) = $event)),
                  placeholder: "请选择团队",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgList), (_org) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: _org.name,
                        value: _org.id
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注：",
              prop: "remarks"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(sendFrom).remarks,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(sendFrom).remarks) = $event)),
                  placeholder: "请输入备注",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "剔除：",
              prop: "remarks"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: _unref(sendFrom).deleteUserIds,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(sendFrom).deleteUserIds) = $event)),
                  props: _unref(casProp),
                  options: _unref(associationOrgUser),
                  "collapse-tags": "",
                  filterable: ""
                }, null, 8, ["modelValue", "props", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司：",
              prop: "companyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(sendFrom).companyIds,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(sendFrom).companyIds) = $event)),
                  style: {"width":"310px"},
                  filterable: "",
                  placeholder: "请选择公司",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysCompany, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        label: group.label,
                        key: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: comp.name,
                              value: comp.id,
                              key: comp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_el_checkbox, {
                modelValue: _unref(sendFrom).repeat,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(sendFrom).repeat) = $event)),
                "true-label": "true",
                "false-label": "false"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: notifyFg.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((notifyFg).value = $event)),
      onClose: _cache[19] || (_cache[19] = ($event: any) => (notifyFromEle.value.resetFields())),
      title: "通知"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (sendNotify())),
          loading: btnFg.value
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "notifyFromEle",
          ref: notifyFromEle,
          model: _unref(sendFrom),
          "label-width": "120px",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "领导：",
              prop: "userIds",
              rules: [ { required: true, message: '请选择领导', trigger: 'change', },]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(sendFrom).userIds,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(sendFrom).userIds) = $event)),
                  placeholder: "请选择领导",
                  multiple: "",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fullUserList), (_user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: _user.label,
                        value: _user.userId
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})